import { render, staticRenderFns } from "./MitPasswordResetFromLinkPage.vue?vue&type=template&id=40a91380&scoped=true"
import script from "./MitPasswordResetFromLinkPage.vue?vue&type=script&lang=js"
export * from "./MitPasswordResetFromLinkPage.vue?vue&type=script&lang=js"
import style0 from "./MitPasswordResetFromLinkPage.vue?vue&type=style&index=0&id=40a91380&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a91380",
  null
  
)

export default component.exports